import { withTransaction } from '@elastic/apm-rum-react';
import { Theme, Typography, makeStyles, createStyles } from '@material-ui/core';
import React from 'react';
import { useMount } from '../hooks/useMount';
import { getAppInsights } from '../TelemetryService';
import PaperColumn from './PaperColumn';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: 'center',
    },
  })
);

const NotFound: React.FunctionComponent = () => {
  const classes = useStyles();

  const { referrer } = document;
  const { origin, href } = window.location;

  useMount(() => {
    getAppInsights().trackEvent({
      name: '404 - Page Not Found.',
      properties: { referrer, origin, href },
    });
  });

  return (
    <div className={classes.root}>
      <PaperColumn>
        <Typography variant="h5" gutterBottom>
          404 Page Not Found
        </Typography>
        <p>We are sorry but the page you are looking for does not exist.</p>
      </PaperColumn>
    </div>
  );
};

export default withTransaction('NotFound', 'component')(NotFound);
